export default "__VITE_ASSET__T09iCiYX__"